// The mobile bottom nav's breakpoint: shown below 768px, desktop header controls from 768px.
export const MOBILE_QUERY = '@media (max-width: 767.98px)'
export const DESKTOP_QUERY = '@media (min-width: 768px)'

// For header controls the mobile bottom nav replaces: hidden only while the bar is on the
// page. `:has` matches the server-rendered nav, so there's no flash before hydration.
export const HIDDEN_WITH_BOTTOM_NAV = {
  [MOBILE_QUERY]: {
    'body:has([data-bottom-nav]) &': { display: 'none' },
  },
}
